import { SegmentCardEvent } from '../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { segmentTrackAction } from '../../../../../../../middlewares/segment/actions/segmentTrackAction/segmentTrackAction';
import { Dispatch, ThunkAction } from '../../../../../../../types/actions';

export const onTabDetailsActive = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.TAB_DETAILS));
    };
    return action;
};
